import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// based off the material ui alert https://material-ui.com/components/alert/#api
export interface Alert {
    title?: string;
    text: string;
    type: "error" | "warning" | "info" | "success";
    variant?: "outlined" | "filled" | "standard";
    ttl?: number;
}

export interface InternalAlert extends Alert {
    date: number;
    ttl: number;
}

interface AlertSlice {
    alerts: InternalAlert[];
}

const initialAlertState: AlertSlice = {
    alerts: [],
};

const DEFAULT_ALERT_TTL = 6000; // 6s

export const alertsSlice = createSlice({
    name: "alerts",
    initialState: initialAlertState,
    reducers: {
        addAlert: (state: AlertSlice, payload: PayloadAction<Alert>) => {
            state.alerts.push({
                date: new Date().getTime(),
                ttl: DEFAULT_ALERT_TTL,
                variant: "standard",
                ...payload.payload,
            });
        },
        removeAlert: (state: AlertSlice, payload: PayloadAction<number>) => {
            state.alerts = state.alerts.filter(({ date }) => date !== payload.payload);
        },
    },
});

export const { addAlert, removeAlert } = alertsSlice.actions;
export default alertsSlice.reducer;
